import {API_URL, CMS_URL, THEME_COLOR} from "../constant"
import React, { useEffect, useState } from 'react';
import HeaderBack from "../layout/HeaderBack";
import { useLocalStorage } from "../useLocalStorage";
import M from "materialize-css";
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepButton from '@mui/material/StepButton';
import Button from '@mui/material/Button';
import { Card, CardMedia, CardContent, Divider } from "@mui/material";
import Typography from '@mui/material/Typography';
import DownloadOutlined from '@mui/icons-material/DownloadOutlined'
import StepLabel from '@mui/material/StepLabel';
import Select from 'react-select';
import Link from "@mui/material/Link";
import banner1 from "../logo.svg"
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import MobileDatePicker from '@mui/lab/MobileDatePicker';
import Stack from '@mui/material/Stack';

import toast, { Toaster } from 'react-hot-toast';
// import { Link } from "react-router-dom";


const Download = (props)=>{
    const [token, setToken] = useLocalStorage("token", "");
    const [categories, setCategories] = useState([]);
    const [files, setFiles] = useState([]);


    function getCategory(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/download/category`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initCategory(){
        let response = await getCategory();
        if(response.status == 200){
            setCategories(response.data);
        }
    }

    function getFile(){
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
        myHeaders.append("x-access-token", token);

        var urlencoded = new URLSearchParams();

        var requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow'
        };

        return fetch(`${API_URL}api/download`, requestOptions)
        .then(response => response.json())
        .catch(error => console.log('error', error))
    }

    async function initFile(){
        let response = await getFile();
        if(response.status == 200){
            setFiles(response.data);
        }
    }

    useEffect(()=>{
        initCategory();
        initFile();
    },[])

    return(
        <React.StrictMode>
            <HeaderBack title="Download" />
            {
                categories.map((value, index)=>{
                    let attachment = files.map((val, idx)=>{
                        if(val.Category == value.Value){
                            return (
                                <Card sx={{maxWidth: 200, margin:"5px"}} key={`attachment-item-${val.ID}`}>
                                    <CardMedia 
                                        component="img"
                                        height="150"
                                        image={`${CMS_URL}/upload/attachment/${val.Thumbnail}`}                 
                                    />
                                    <CardContent>
                                        <Typography gutterBottom variant="h6" component="div">
                                            {val.Title}
                                        </Typography>
                                        <Divider />
                                        <Typography variant="body2" color="text.secondary">
                                            {val.Description}
                                        </Typography>
                                        <Box sx={{width:"100%", textAlign:"right",marginTop:"10px"}}>
                                            <Link href={`${CMS_URL}/upload/attachment/${val.Attachment}`} target="_blank" download>
                                                <Button variant="outlined" startIcon={< DownloadOutlined/>} componen="link">
                                                    Download
                                                </Button>
                                            </Link>
                                        </Box>
                                    </CardContent>
                                </Card>
                            );
                        }
                    })
                    attachment = attachment.filter(val => val!= undefined);
                    if(attachment.length > 0 && attachment[0] == undefined) attachment = []
                    // console.log(attachment);
                    return(
                        <Box sx={{width:"100%", backgroundColor:"white", marginTop:"10px", padding:"10px"}}>
                            <Typography key={`download-header-${index}}`} variant="h4" component="h4">{value.Name}</Typography>
                            <Stack direction="row" sx={{display:"flex", flexWrap:"wrap"}}>
                                {
                                    (attachment.length > 0) ?(
                                        attachment
                                    )
                                    :(
                                        <Card sx={{width:"100%"}} key={`noattachment-item-${value.Value}`}>
                                            <CardContent>
                                                <Typography variant="body2" color="text.secondary">
                                                    No attachment for this category
                                                </Typography>
                                            </CardContent>
                                        </Card>
                                    )
                                }
                            </Stack>
                        </Box>
                    );
                })
            }
        </React.StrictMode>
    );
}


export default Download;